export default (namespace) => ({
  [`${namespace}.licenceConsent`]: 'Política de Privacidad',
});
